const fieldValidation = {
  required: (name: string) => `${name} is required.`,
  maxLength: (name: string, maxLength: number) =>
    `${name} can be at most ${maxLength} character${
      maxLength === 1 ? "" : "s"
    } long.`,
  minLength: (name: string, minLength: number) =>
    `${name} must be at least ${minLength} character${
      minLength === 1 ? "" : "s"
    } long.`,
};

export { fieldValidation };
